module.exports = __webpack_public_path__ + "media/images/players/KAYMER_MARTIN-d1ff505ce812ba051dfaed2201d079ed.png";